import React, { useState, useEffect } from "react";
import {
  Box,
  FormControl,
  FormLabel,
  TextField,
  Button,
  MenuItem,
  Select,
  FormHelperText,
  Checkbox,
} from "@mui/material";

import { fields } from "./UserFormConfig";

function UserForm({ onSubmit, initialData = {} }) {
  const [formData, setFormData] = useState({});
  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    if (Object.keys(initialData).length > 0) {
      setFormData((prev) => ({
        ...prev,
        ...initialData,
        requireTraining: !initialData.hasSeenTrainingVideo, // derive from backend
      }));
    } else {
      setFormData({
        sendWelcomeEmail: false,
        requireTraining: true, // default for new users
      });
    }
  }, [initialData]);

  const validateForm = () => {
    const errors = {};
    fields.forEach((field) => {
      if (field.validation === "required") {
        const value = formData[field.key];
        if (!value) {
          errors[field.key] = `${field.name} is required`;
        }
      }
    });
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = () => {
    if (!validateForm()) return;

    const payload = {
      ...formData,
      hasSeenTrainingVideo: !formData.requireTraining,
    };

    delete payload.requireTraining;
    onSubmit(payload);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (formErrors[name]) {
      setFormErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  return (
    <Box>
      {fields.map((field) => {
        const errorMsg = formErrors[field.key];
        return (
          <FormControl
            key={field.key}
            fullWidth
            error={Boolean(errorMsg)}
            style={{ marginBottom: 16 }}
          >
            {field.type === "checkbox" ? (
              <Box display="flex" alignItems="center">
                <Checkbox
                  name={field.key}
                  checked={formData[field.key] ?? false}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [field.key]: e.target.checked,
                    })
                  }
                />
                <FormLabel>{field.name}</FormLabel>
              </Box>
            ) : (
              <>
                <FormLabel>{field.name}</FormLabel>
                {field.type === "select" ? (
                  <Select
                    name={field.key}
                    value={formData[field.key] || ""}
                    onChange={handleChange}
                    displayEmpty
                  >
                    <MenuItem value="">
                      <em>Select an option</em>
                    </MenuItem>
                    {field.options?.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                ) : (
                  <TextField
                    name={field.key}
                    type={field.type}
                    placeholder={field.placeholder || ""}
                    value={formData[field.key] || ""}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    disabled={
                      Object.keys(initialData).length > 0 &&
                      (field.key === "fullName" || field.key === "email")
                    }
                  />
                )}
              </>
            )}
            {errorMsg && <FormHelperText>{errorMsg}</FormHelperText>}
          </FormControl>
        );
      })}

      <Box display="flex" flexDirection="column" gap={2} mt={4}>
        <Button variant="contained" onClick={handleSubmit} fullWidth>
          Submit
        </Button>
      </Box>
    </Box>
  );
}

export default UserForm;
